import { FC } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { UnitsInformationMobile } from "./Mobile";
import { UnitsInformationTablet } from "./Tablet";
import { UnitsInformationDesktop } from "./Desktop";
import { useConfig } from "../../context/ConfigProvider";

import { IUnitsInformation } from "./type";
import { Promotion } from "./subComponents/Promotion";

export const UnitsInformation: FC<IUnitsInformation> = (props) => {
  const { configuration } = useConfig();
  return (
    <Box sx={{ py: 0.5 }}>
      <Card
        variant="outlined"
        sx={{
          backgroundColor: "transparent",
          borderColor: "#EFEFEF",
          boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05);",
        }}
      >
        {(configuration?.displayPromoPublicDescription !== false) && <Promotion {...props} />}
        <UnitsInformationMobile {...props} />
        <UnitsInformationTablet {...props} />
        <UnitsInformationDesktop {...props} />
      </Card>
    </Box>
  );
};

export type { IUnitsInformation } from "./type";

// export default UnitsInformation;
